import { Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";

import { scbsmbLossMonthlyAction } from "../../actions/energyAction";
import GraphLoader from "../../components/GraphLoader";

/* ##### Heatmap Component  ##### */

const Heatmap = ({ databaseStr, scbsmbDetail, selectedLebel }) => {
  const { scbsmbLoss, loading } = useSelector((state) => state.scbsmbLoss);
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { projectDetail } = useSelector((state) => state.projectDetail);
  const [uniqueKyes, setUniqueKyes] = useState([]);
  /* ###  End of Function To Get Inverter Number from URL   ### */
  // const [heatmapData, setHeatmapData] = useState(null);
  const [title, setTitle] = useState(null);
  // useEffect(() => {
  //   if (scbsmbLoss) {
  //     let heatmapData = [];
  //     const set = new Set();

  //     scbsmbLoss?.forEach((e) => {
  //       let finalObj = {};
  //       finalObj["name"] = e["Date"];
  //       let newObj = {};
  //       let countObj = {};

  //       Object.keys(e || {}).forEach((ee) => {
  //         if (ee != "Date") {
  //           // let string =ee
  //           let string =
  //             projectDetail?.plantDetail?.string === "STRING"
  //               ? ee?.substring(0, 9)
  //               : ee.substring(0, 6);
  //           set.add(string);
  //           if (!isNaN(newObj[string])) {
  //             newObj[string] = Number(newObj[string]) + Number(e[ee]);
  //             countObj[string]++;
  //           } else {
  //             newObj[string] = Number(e[ee]);
  //             countObj[string] = 1;
  //           }
  //         }
  //       });

  //       Object.keys(newObj || {}).forEach((e) => {
  //         finalObj[e] = (newObj[e] / countObj[e]).toFixed(2);
  //       });
  //       heatmapData.push(finalObj);
  //     });
  //     setUniqueKyes([...set].sort());

  //     let result = heatmapData?.map((e, index) => {
  //       let obj = {};
  //       obj["name"] = e["name"];
  //       obj["data"] = [];
  //       Object.keys(e || {}).forEach((ee) => {
  //         if (ee != "name") {
  //           obj["data"].push({
  //             x: ee,
  //             y: !isNaN(e[ee]) ? Number(e[ee])?.toFixed(0) : 0,
  //           });
  //         }
  //       });

  //       return obj;
  //     });
  //     setHeatmapData(result);
  //   }
  // }, [scbsmbLoss]);

  // Memoize your heatmap data processing
  const heatmapData = useMemo(() => {
    if (!scbsmbLoss) return null;

    const set = new Set();
    const processedData = scbsmbLoss?.map((e) => {
      const finalObj = { name: e["Date"] };
      const newObj = {};
      const countObj = {};

      Object.keys(e || {}).forEach((ee) => {
        if (ee !== "Date") {
          const stringKey =
            projectDetail?.plantDetail?.string === "STRING"
              ? ee?.substring(0, 9)
              : ee.substring(0, 6);

          set.add(stringKey);
          newObj[stringKey] = (newObj[stringKey] || 0) + Number(e[ee]);
          countObj[stringKey] = (countObj[stringKey] || 0) + 1;
        }
      });

      Object.keys(newObj).forEach((key) => {
        finalObj[key] = (newObj[key] / countObj[key]).toFixed(2);
      });

      return finalObj;
    });

    setUniqueKyes([...set].sort());

    return processedData.map((e) => ({
      name: e.name,
      data: Object.entries(e)
        .filter(([key]) => key !== "name")
        .map(([x, y]) => ({
          x,
          y: !isNaN(y) ? Number(y).toFixed(0) : 0,
        })),
    }));
  }, [scbsmbLoss, projectDetail]);

  useEffect(() => {
    let { inverter, block, scbsmb, stack } = scbsmbDetail;
    inverter = inverter?.split(" ")[1];
    block = block?.split(" ")[1];
    scbsmb = scbsmb?.split(" ")[1];
    stack = stack?.split(" ")[1];
    setTitle(
      (projectDetail?.plantDetail?.block_name || "BL") +
        "-" +
        block +
        "-" +
        "INV-" +
        inverter +
        (stack ? "-STACK-" + stack : "")
    );
  }, [scbsmbDetail]);

  useEffect(() => {
    dispatch(scbsmbLossMonthlyAction(scbsmbDetail, selectedLebel, databaseStr));
  }, [scbsmbDetail, dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (selectedLebel?.endTimestamp) {
        dispatch(
          scbsmbLossMonthlyAction(scbsmbDetail, selectedLebel, databaseStr)
        );
      }
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [
    dispatch,
    selectedLebel?.endTimestamp,
    selectedLebel?.startTimestamp,
    selectedLebel?.dateRangeType,
    scbsmbDetail,
  ]);
  const todayDate = new Date().toLocaleDateString();
  const startDate = selectedLebel?.startDate
    ? new Date(selectedLebel?.startDate).toLocaleDateString()
    : null;
  const endDate = selectedLebel?.endDate
    ? new Date(selectedLebel?.endDate).toLocaleDateString()
    : null;
  useEffect(() => {
    if (
      selectedLebel?.startTimestamp &&
      selectedLebel?.endTimestamp &&
      projectDetail?.plantDataAvailability?.realtimeData &&
      selectedLebel?.dateRangeType ===
        projectDetail?.plantDataAvailability?.timeInterval &&
      todayDate === startDate &&
      todayDate === endDate
    ) {
      const interval = setInterval(() => {
        dispatch(
          scbsmbLossMonthlyAction(scbsmbDetail, selectedLebel, databaseStr)
        );
      }, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [
    dispatch,
    scbsmbDetail,
    selectedLebel?.endTimestamp,
    selectedLebel?.startTimestamp,
    selectedLebel?.dateRangeType,
    databaseStr,
    projectDetail,
  ]);

  const dynamicChartHeight = Math.max(heatmapData?.length * 40, 500); // 40px per row, min 500px

  return (
    <>
      {
        <Grid container textAlign={"center"}>
          <Grid
            item
            sx={{ boxShadow: 2 }}
            xl={11.8}
            lg={11.8}
            md={11.8}
            sm={11.8}
            xs={11.8}
            style={{
              background:
                "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
              // borderRadius: "8px",
              margin: "1vmax auto",
              padding: "0.5vmax",
            }}
          >
            <Grid
              item
              lg={12}
              sx={{
                position: "relative",
                backgroundColor: "white",
                padding: "1rem 0",
                minHeight: "85vh",
                height: "fit-content",
              }}
            >
              <h3>
                Heatmap of Avg. {scbsmbDetail.scbsmbType}(s) Normalized-STC
                Current Loss (%) ({title})
              </h3>
              {loading ? (
                <div
                  style={{
                    height: "75vh",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GraphLoader />
                </div>
              ) : heatmapData?.length > 0 ? (
                <Chart
                  style={{
                    margin: "auto",
                    width: "95%",
                    minWidth: "500px",
                  }}
                  height={dynamicChartHeight}
                  type="heatmap"
                  options={{
                    chart: {
                      toolbar: {
                        show: false,
                        show: user?.userLevel !== 1 ? false : true,
                        // tools: {

                        // },
                      },
                    },
                    // tooltip: {
                    //   y: {
                    //     formatter: (v) => (v == 0 ? v : -v),
                    //   },
                    // },

                    plotOptions: {
                      heatmap: {
                        enableShades: false,
                        shadeIntensity: 0,
                        colorScale: {
                          // inverse: false,
                          ranges: [
                            {
                              from: 1,
                              to: 100,
                              name: "low",
                              color: "#00A100",
                            },
                            {
                              from: -5,
                              to: 0,
                              name: "medium",
                              color: "#128FD9",
                            },
                            {
                              from: -15,
                              to: -6,
                              name: "high",
                              color: "#FFB200",
                            },
                            {
                              from: -100,
                              to: -16,
                              name: "extreme",
                              color: "#FF0000",
                            },
                          ],
                        },
                      },
                    },
                    xaxis: {
                      categories: uniqueKyes,
                      position: "top",
                      labels: {
                        style: {
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          fontFamily:
                            "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                        },
                      },
                    },
                    yaxis: {
                      labels: {
                        style: {
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          fontFamily:
                            "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                        },
                      },
                    },
                    grid: {
                      show: true,
                      borderColor: "red",
                    },

                    dataLabels: {
                      enabled: false,
                    },
                    legend: {
                      showForSingleSeries: true,
                      show: true,
                      position: "top",
                    },
                  }}
                  series={heatmapData || []}
                />
              ) : (
                <div
                  style={{
                    height: "75vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                 { heatmapData?.length==0 &&  todayDate === startDate &&
      todayDate === endDate ? "Data Not Available On SCADA API":"Data Not Available"}
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      }
    </>
  );
};

export default Heatmap;
